import React from "react";

import DataGrid, {
  Column,
  ColumnChooser,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Item,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Toolbar,
} from "devextreme-react/data-grid";

import { useWindowDimensions } from "@app/contexts";
import { useFxSelector } from "@app/statefx";
import { aggregateSeries } from "@app/statefx/selectors/uiFiscalBooks.sel";

import "./serials.scss";

export const IssuedSerials = () => {
  const {
    height: fullHeight,
    headersFooters,
    jgDrawerHeight,
  } = useWindowDimensions();
  const fiscalBooks = useFxSelector(aggregateSeries);

  const rowPrepared = (e: any) => {
    if (e.rowType === "data") {
      switch (true) {
        case e?.data.isDuplicate: {
          e.rowElement.classList.add("withDuplicateBackground");
          break;
        }
        case e?.data.isStartingGap:
        case e?.data.isEndingGap: {
          e.rowElement.classList.add("withGapBackground");

          break;
        }
        default:
          break;
      }
    }
  };
  return (
    <DataGrid
      id="issuedSerials"
      dataSource={fiscalBooks}
      showBorders={true}
      columnAutoWidth={true}
      height={jgDrawerHeight}
      wordWrapEnabled={true}
      onRowPrepared={rowPrepared}
    >
      <FilterRow visible={false} />
      <Selection mode="none" />
      <HeaderFilter visible={true} />
      <GroupPanel visible={false} />
      <ColumnChooser enabled={true} />
      <Paging enabled={false} />
      <Scrolling mode="virtual" />
      <SearchPanel visible={true} />
      <Toolbar>
        <Item location="before" name="searchPanel" locateInMenu="auto" />
        <Item location="after" name="columnChooserButton" locateInMenu="auto" />
      </Toolbar>

      <Column dataField="id" caption="ID" visible={false} />
      <Column
        dataField="text"
        dataType="string"
        // width={300}
        caption="SeriaNr."
      />
      <Column
        dataField="date"
        dataType="date"
        // width={110}
        caption="Date"
      />
      <Column
        dataField="status"
        dataType="string"
        caption="Status"
        visible={true}
        width={80}
      />

      <Column
        dataField="isDuplicate"
        dataType="boolean"
        caption="Dup."
        visible={true}
        width={110}
      />
      <Column
        dataField="isStartingGap"
        dataType="boolean"
        caption="Urmeaza o lipsa"
        visible={true}
        width={110}
      />
      <Column
        dataField="isEndingGap"
        dataType="boolean"
        caption="Dupa o lipsa"
        visible={true}
        width={110}
      />
      <Column
        dataField="parsedNumber"
        caption="Parsed Number"
        dataType="number"
        sortIndex={0}
        sortOrder="desc"
        visible={false}
      />
    </DataGrid>
  );
};
